import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Building2, Crown, CreditCard, Menu, MonitorSmartphone, DollarSign } from "lucide-react";
import { useState } from "react";
import UserMenu from "@/components/UserMenu";

const NAV = [
  { to: "/platform", label: "Overview", Icon: LayoutDashboard, end: true, testid: "platform-nav-overview" },
  { to: "/platform/companies", label: "Companies", Icon: Building2, testid: "platform-nav-companies" },
  { to: "/platform/corporate", label: "Corporate accounts", Icon: Crown, testid: "platform-nav-corporate" },
  { to: "/platform/payments", label: "Payments", Icon: CreditCard, testid: "platform-nav-payments" },
  { to: "/platform/pricing", label: "Pricing", Icon: DollarSign, testid: "platform-nav-pricing" },
  { to: "/platform/assets", label: "Devices", Icon: MonitorSmartphone, testid: "platform-nav-assets" },
];

export default function PlatformLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="platform-page">
      {mobileNavOpen && (
        <div className="fixed inset-0 z-40 bg-slate-900/50 md:hidden" data-testid="platform-mobile-overlay" onClick={() => setMobileNavOpen(false)} />
      )}
      <aside
        onClick={(e) => { if (e.target.closest("a,button")) setMobileNavOpen(false); }}
        className={`w-60 shrink-0 bg-white border-r border-slate-200 flex flex-col fixed inset-y-0 z-50 overflow-y-auto transform transition-transform duration-200 md:translate-x-0 ${mobileNavOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex items-center gap-3 px-4 py-5 border-b border-slate-100">
          <img src="/logerd-logo.png" alt="Logerd" className="h-10 w-10 object-contain flex-shrink-0" />
          <div>
            <div className="font-display text-base font-bold tracking-tight text-slate-900">Logerd Console</div>
            <div className="text-[11px] text-slate-500">Platform owner</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map(({ to, label, Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm font-medium transition ${
                  isActive ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"
                }`
              }
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex-1 md:ml-60 min-w-0">
        <div className="md:hidden sticky top-0 z-30 flex items-center gap-3 bg-white border-b border-slate-200 px-4 py-3">
          <button onClick={() => setMobileNavOpen(true)} data-testid="platform-mobile-menu-btn"
                  className="h-9 w-9 rounded-lg border border-slate-200 inline-flex items-center justify-center text-slate-700">
            <Menu className="h-5 w-5" />
          </button>
          <span className="font-display font-bold text-slate-900 flex-1">Logerd Console</span>
          <UserMenu roleLabel="Platform Owner" />
        </div>
        <div className="hidden md:flex justify-end px-6 pt-3" data-testid="platform-topbar">
          <UserMenu roleLabel="Platform Owner" />
        </div>
        <Outlet />
      </div>
    </div>
  );
}
